export const WORKER_TOPIC = {
  initProcess: 'initProcess',
  loadProcess: 'loadProcess',
  addProcess: 'addProcess',
  deleteProcess: 'deleteProcess',
  generateReport:'generateReport',
  getStatusReport: 'getStatusReport'
};
